import React, { PureComponent, Fragment } from 'react';
import T from 'prop-types';
// utils
import { getSubscriptionAccess } from '../../containers/Routes/utils';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
// components
import { Link, NavLink } from 'react-router-dom';
import { Collapse } from 'react-collapse';
import LadderLogo from '../LadderLogo/LadderLogo';
import HeaderIcon from './components/HeaderIcon';
import MenuBurger from './components/MenuBurger';
import UserDropdown from '../UserDropdown/UserDropdown';
// hoc
import withSizes from 'react-sizes';
import onClickOutside from 'react-onclickoutside';
import { withRouter } from 'react-router-dom';
// shapes
import userShape from '../../shapes/user';
// styles
import styles from './MainHeader.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

export const HeadLink = ({ hide, children, ...otherProps }) => {
  return (
    <NavLink
      activeClassName={styles.active}
      className={cx({ hidden: hide })}
      {...otherProps}
    >
      {children}
    </NavLink>
  );
};

export class MainHeader extends PureComponent {
  state = {
    isMenuOpen: false,
  };

  toggleMenu = () => {
    this.setState(prevState => ({
      isMenuOpen: !prevState.isMenuOpen,
    }));
  };

  closeMenu = () => {
    this.setState({
      isMenuOpen: false,
    });
  };

  handleClickOutside = () => {
    this.closeMenu();
  };

  renderLinks = () => {
    const {
      isTablet,
      currentUser,
      isLogged,
      match: { url },
    } = this.props;
    const { username, profile_color, role, progress = {}, email } =
      currentUser || {};
    const isSupport = role === 'support';
    const { isMenuOpen } = this.state;
    const isDesktop = !isTablet;
    const isZero = !isSupport ? progress.module === 0 : false;
    const hasSubscription = getSubscriptionAccess(currentUser);
    const isSignUpUrl = url.startsWith('/signup');

    const NonLoggedLinks = () => (
      <Fragment>
        <HeadLink to="/about">About</HeadLink>
        <HeadLink to="/login">Login</HeadLink>
      </Fragment>
    );

    const HeadLinkDashboard = () => (
      <HeadLink to="/dashboard" hide={isSignUpUrl}>
        Dashboard
      </HeadLink>
    );

    const HeadLinkRecoveryPlan = () => (
      <HeadLink to="/recovery-plan" hide={isSignUpUrl}>
        Recovery plan
      </HeadLink>
    );

    const HeadLinkResources = () => (
      <HeadLink to="/resources" hide={isSupport || isSignUpUrl}>
        Resources
      </HeadLink>
    );

    if (!isLogged) {
      return isDesktop ? (
        <nav className={styles.navigation}>
          <NonLoggedLinks />
        </nav>
      ) : (
        <nav className={styles.navigation}>
          <MenuBurger toggleMenu={this.toggleMenu} isMenuOpen={isMenuOpen} />
          <Collapse isOpened={isMenuOpen} onClick={this.closeMenu}>
            <NonLoggedLinks />
          </Collapse>
        </nav>
      );
    }

    if (isDesktop)
      return (
        <nav className={styles.navigation}>
          <HeadLinkDashboard />
          <HeadLinkRecoveryPlan />
          <HeadLinkResources />
          <UserDropdown
            username={username || email}
            color={profile_color || '#33C370'}
            isSupport={isSupport}
            hasSubscription={hasSubscription}
          />
        </nav>
      );

    if (isTablet)
      return (
        <nav className={styles.navigation}>
          <MenuBurger toggleMenu={this.toggleMenu} isMenuOpen={isMenuOpen} />
          <Collapse isOpened={isMenuOpen} onClick={this.closeMenu}>
            <HeadLinkRecoveryPlan />
            <HeadLinkDashboard />
            <HeadLink to="/profile">Profile</HeadLink>
            <HeadLinkResources />
            <HeadLink to="/billing" hide={isSupport}>
              Billing
            </HeadLink>
            <HeadLink to="/help" hide={isSupport}>
              Help
            </HeadLink>
            <HeadLink to="/logout">Log out</HeadLink>
          </Collapse>
        </nav>
      );
  };

  render() {
    const { backLink, toggleSidebar, isLogged, currentUser } = this.props;
    const { role, progress = {} } = currentUser || {};
    const isSupport = role === 'support';
    const isZero = !isSupport ? progress.module === 0 : false;

    return (
      <header className={styles.header}>
        <div className={styles['brand-box']} onClick={this.closeMenu}>
          <Link to="/" className={styles.brand}>
            <LadderLogo />
            <h2>
              Ladder<span>out</span>
            </h2>
          </Link>
          <HeaderIcon
            isToggled={isLogged && !isZero}
            toggleSidebar={toggleSidebar}
            backLink={backLink}
          />
        </div>
        {this.renderLinks()}
      </header>
    );
  }
}

MainHeader.propTypes = {
  isLogged: T.bool,
  isTablet: T.bool.isRequired,
  currentUser: userShape,
  toggleSidebar: T.func,
};

const mapSizesToProps = ({ width }) => ({
  isTablet: width < 768,
});

const enhance = compose(
  withRouter,
  connect(state => ({
    isLogged: state.auth.authenticated,
    currentUser: state.auth.user,
  })),
  withSizes(mapSizesToProps),
  onClickOutside
);

export default enhance(MainHeader);



// WEBPACK FOOTER //
// ./src/components/MainHeader/MainHeader.js